module.exports = __webpack_public_path__ + "img/bg.44a54bea.png";